<template>
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.833 23.3376C18.5944 23.3376 20.833 25.5762 20.833 28.3377C20.833 31.0992 18.5944 33.3378 15.833 33.3378C13.0716 33.3378 10.833 31.0992 10.833 28.3377C10.833 25.5762 13.0716 23.3376 15.833 23.3376Z"
            fill="currentColor"
        />
        <path
            d="M24.166 6.66963C21.4046 6.66963 19.166 8.90826 19.166 11.6698C19.166 14.4312 21.4046 16.6699 24.166 16.6699C26.9274 16.6699 29.166 14.4312 29.166 11.6698C29.166 8.90826 26.9274 6.66963 24.166 6.66963Z"
            fill="currentColor"
        />
        <path
            d="M25 28.2686L36.6667 28.2686"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
        />
        <path
            d="M15 11.6006L3.33333 11.6006"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
        />
        <path
            d="M3.33301 28.2686L6.66634 28.2686"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
        />
        <path
            d="M36.666 11.6006L33.3327 11.6006"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "TuningIcon",
});
</script>
